// @module BTM.ItemSearcherCustomization.ItemSearcherCustomization
define('BTM.ItemSearcherCustomization.ItemSearcherCustomization.View'
,	[
	'btm_itemsearchercustomization_itemsearchercustomization.tpl'
	
	,	'BTM.ItemSearcherCustomization.ItemSearcherCustomization.SS2Model'
	
	,	'Backbone'
    ]
, function (
	btm_itemsearchercustomization_itemsearchercustomization_tpl
	
	,	ItemSearcherCustomizationSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class BTM.ItemSearcherCustomization.ItemSearcherCustomization.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_itemsearchercustomization_itemsearchercustomization_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new ItemSearcherCustomizationModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return BTM.ItemSearcherCustomization.ItemSearcherCustomization.View.Context
	,	getContext: function getContext()
		{
			//@class BTM.ItemSearcherCustomization.ItemSearcherCustomization.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
